import React from 'react';
import PasswordForceResetInit from '../../components/student-password-reset-section/PasswordForceResetInitialization';

const PasswordForceReset = (props) => (
    <PasswordForceResetInit {...props} />
);

export default PasswordForceReset;